export enum ESearchType {
  Product = 'produk',
  Outlet = 'toko',
  Service = 'layanan',
  OutletDetail = 'detailToko',
}
